import React from 'react';
import { Select as CustomSelect } from 'shared/Inputs';
import { Option } from 'shared/interface/globalInterface';

import styles from './Select.module.scss';
import { Props } from './Select.types';

const Select: React.FC<Props> = ({
  placeholder,
  disabled,
  required,
  options,
  handleClick,
  searchable,
  value,
  name,
  onBlur,
  noOptionsText,
  confirm,
}) => {
  const selectedOption = options.find((o) => o.value === value);
  const selectedLabel = selectedOption ? selectedOption.option : '';

  const handleSelection = (option: Option) => {
    if (handleClick) {
      if (selectedOption !== undefined && selectedOption.value !== option.value && confirm) {
        return window.confirm(confirm.text) ? handleClick(option) : undefined;
      } else {
        handleClick(option);
      }
    }
  };

  return (
    <div className={styles.selectWrapper}>
      <select hidden={true} value={value} name={name} disabled={disabled} onChange={() => {}}>
        <option disabled value="" className="placeholder">
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={`${name}-${option.id || option.value}`} value={(option.value || '').toString()}>
            {option.option}
          </option>
        ))}
      </select>

      <CustomSelect
        options={options}
        name={name}
        onSelected={handleSelection}
        disabled={disabled || false}
        selected={{ value: value.toString(), label: selectedLabel }}
        isRequired={required}
        searchable={searchable}
        placeholderText={placeholder}
        handleBlur={onBlur}
        noOptionsText={noOptionsText}
      />
    </div>
  );
};

export default Select;
